import { AxiosResponse } from 'axios';

import apiClient from './client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { BookingDto, CreateBookingDto } from '../interfaces/booking';
import { PageResultDto } from '../interfaces/page';
import { SuggestedServicesDto } from '../interfaces/suggestedServices';

interface BookingService {
  search(queryParams?: any): Promise<PageResultDto<BookingDto>>;
  get(id: number): Promise<BookingDto>;
  create(postData: CreateBookingDto): Promise<AxiosResponse<BookingDto>>;
  update(id: number, postData: CreateBookingDto): Promise<AxiosResponse<BookingDto>>;
  delete(id: number): Promise<void>;
  suggestedServices(clientId: number, branchId: number, employeeId?: number | null): Promise<SuggestedServicesDto>;
}

const endpoints = {
  search: `/bookings`,
  get: (id: number) => `/bookings/${id}`,
  create: `/bookings`,
  update: (id: number) => `/bookings/${id}`,
  delete: (id: number) => `/bookings/${id}`,
  suggestedServices: '/bookings/suggested-services',
};

export const bookingsService: BookingService = {
  search: async (queryParams?: any): Promise<PageResultDto<BookingDto>> => {
    const response: AxiosResponse<ApiResponseDto<PageResultDto<BookingDto>>> = await apiClient.get(endpoints.search, {
      params: { ...queryParams },
      paramsSerializer: { indexes: null },
    });

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  get: async (id: number): Promise<BookingDto> => {
    const response: AxiosResponse<ApiResponseDto<BookingDto>> = await apiClient.get(endpoints.get(id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  create: async (postData: CreateBookingDto): Promise<AxiosResponse<BookingDto>> => {
    return await apiClient.post(endpoints.create, postData);
  },
  update: async (id: number, postData: CreateBookingDto): Promise<AxiosResponse<BookingDto>> => {
    return await apiClient.put(endpoints.update(id), postData);
  },
  delete: async (id: number): Promise<void> => {
    const response: AxiosResponse<ApiResponseDto<void>> = await apiClient.delete(endpoints.delete(id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }
  },
  suggestedServices: async (clientId: number, branchId: number, employeeId?: number | null): Promise<SuggestedServicesDto> => {
    const response: AxiosResponse<ApiResponseDto<SuggestedServicesDto>> = await apiClient.get(endpoints.suggestedServices, {
      params: { clientId, branchId, ...(employeeId != null ? { employeeId } : {}) },
    });

    if (response.data.errors) {
      throw new Error(response.data.errors.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
};
